import React, { Component } from "react";
import {
  Form,
  Input,
  Button,
  Spin,
  Alert,
  Collapse,
  Descriptions,
  Flex,
} from "antd";
import {
  CheckOutlined,
  ReloadOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import "dayjs/locale/th";
import Apiauth from "../../../api/Apiauth";
import { openNotification, showToast } from "../../../utils";
import { CopyTextToClipboard } from "../../../helpers/copy";
import ComponentSearch from "./componentSearch";
import { BankData } from "../../../Data/BankData";
import { itemsDescriptions } from "../../../components/Slipmate/itemsDescriptions";
const statusFalse = ["NOT_MATCH", "DUPLICATED"];

class ComponentVerifySlipOut extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      response: null,
      bankCode: null,
      lableRef: "Reference No.",
      error: null,
      customer_uuid: null,
      showContent: false,
      isConfirm: false,
    };
    this.inputRef = React.createRef();
    this.handleFocusAll = this.handleFocusAll.bind(this);
  }

  componentDidMount() {
    this.setState({ lableRef: "Reference No.", showContent: false });
  }
  handleFocusAll() {
    const { uuid } = this.props;
    if (uuid) {
      CopyTextToClipboard(uuid);
    }
    this.inputRef.current.focus({
      cursor: "all",
    });
  }
  filterBankcode = async (bankID) => {
    if (!bankID) return null;
    let bankCode = bankID;

    if (bankCode === "kkp") {
      bankCode = "KKP";
    }

    const bank = BankData?.find((b) => b.bank_id === bankCode);
    return bank ? bank?.bankCode : null;
  };

  handleSubmit = async (values) => {
    const { transRef } = values;
    const { bankCode, customer_uuid } = this.state;
    const { t } = this.props;

    if (!customer_uuid) {
      showToast("error", t("customer_uuid_not_found"));
      return;
    }

    let bank_code = await this.filterBankcode(bankCode);

    if (!bank_code) {
      showToast("error", t("bank_code_not_found"));
      return;
    }

    var raw = {
      sendingBank: bank_code,
      transRef: transRef,
      customerUuid: customer_uuid,
    };
    try {
      this.setState({ loading: true, response: null, error: null });

      const apiResponse = await Apiauth.getUploadNoSlip(raw);

      if (apiResponse.status !== 200) {
        const errorData = apiResponse.data;
        showToast(
          "error",
          `${t("api_error")}: ${apiResponse.status} ${apiResponse.statusText}`
        );
        throw new Error(
          errorData.message ||
            `${t("api_error")}: ${apiResponse.status} ${apiResponse.statusText}`
        );
      }
      if (statusFalse.includes(apiResponse?.data?.status)) {
        openNotification(
          "warning",
          apiResponse?.data?.status,
          apiResponse?.data?.note
        );
        this.props.handleShowBtnConfirm(false, apiResponse);

        this.setState({
          loading: false,
          response: apiResponse,
          isConfirm: false,
        });
        this.props.handleChangeLoading(false);
        return;
      }

      // MATCHED
      this.props.handleChangeLoading(false);
      this.props.handleShowBtnConfirm(false, apiResponse);
      this.setState({ response: apiResponse, error: null, isConfirm: true });
      showToast("success", t("slip_matched"));
    } catch (error) {
      showToast(
        "error",
        `${t("api_call_error")}: ${error?.response?.data?.message || error?.message}`
      );
      console.error("API call error:", error);
      this.setState({ error: error, response: null });
    } finally {
      this.setState({ loading: false, bankCode: null, customer_uuid: null });
    }
  };

  handleBankChange = (item) => {
    if (item) {
      this.setState({ bankCode: item.bankCode, lableRef: item.lableRef });
    }
  };
  setDataSearchCustomers = (item) => {
    console.log(item);
    // Note : key = bank_code, title = merchantId,  value = customer_uuid,
    let { value, title } = item;
    if (value) {
      this.setState({
        customer_uuid: value,
        showContent: true,
        bankCode: title,
      });
    } else {
      this.setState({ customer_uuid: null, showContent: false });
    }
  };
  render() {
    const {
      loading,
      response,
      error,
      lableRef,
      showContent,
      customer_uuid,
      isConfirm,
    } = this.state;
    const { t, resAllDataMerchang } = this.props;
    let statusCode = error?.response?.data?.statusCode || error?.status;
    let message = error?.response?.data?.message || error?.message;
    let columnProps = {
      xxl: 1,
      xl: 1,
      lg: 1,
      md: 1,
      sm: 1,
      xs: 1,
    };
    const descriptionsData = itemsDescriptions({
      resAllDataMerchang: resAllDataMerchang,
      apiResponse: response,
      previewImage: null,
    });
    const genExtra = () => (
      <Flex gap="middle" justify="end" horizontal>
        {isConfirm && (
          <Button
            style={{ fontSize: 13 }}
            type="primary"
            size="small"
            onClick={() => this.props.handleConfirmTransaction(response?.data)}
          >
            <CheckOutlined /> {t("APPROVE")}
          </Button>
        )}
        <Button
          size="small"
          style={{ fontSize: 13 }}
          onClick={() => {
            this.setState({
              response: null,
              isConfirm: false,
            });
          }}
          icon={<ReloadOutlined />}
        >
          {t("Reset")}
        </Button>
      </Flex>
    );
    const itemsCollapse = [
      {
        key: "1",
        label: t("Details"),
        children: (
          <div className="p-1">
            <Descriptions
              bordered
              span={12}
              size="small"
              column={columnProps}
              items={descriptionsData}
            />
          </div>
        ),
        extra: genExtra(),
      },
    ];
    return (
      <>
        {error && (
          <Alert
            message={`Status Code: ${statusCode}`}
            description={message}
            type="error"
            showIcon
            closable
            onClose={() => this.setState({ error: null })}
            style={styles.alert}
          />
        )}

        {response && (
          <div style={styles.responseSection}>
            <Alert
              message={response?.data?.status}
              type={
                statusFalse.includes(response?.data?.status)
                  ? "warning"
                  : "success"
              }
              description={response?.data?.note}
              showIcon
            />
            <Collapse
              ghost
              items={itemsCollapse}
              defaultActiveKey={["1"]}
              expandIconPosition="start"
            />
          </div>
        )}
        <div className="container-sm mt-2" style={styles.container}>
          <Form
            ref={this.formRef}
            layout="vertical"
            onFinish={this.handleSubmit}
            style={styles.form}
            className="mt-2"
          >
            <Form.Item
              name="customer_uuid"
              label={t("Customer's")}
              rules={[
                {
                  required: !customer_uuid,
                  message: t("please_require_customer"),
                },
              ]}
            >
              <ComponentSearch
                onCustomerSelected={this.setDataSearchCustomers}
                t={t}
              />
            </Form.Item>

            <Form.Item
              label={lableRef}
              className={`${showContent ? "animate" : "d-none"}`}
              name="transRef"
              rules={[
                {
                  required: true,
                  message: `${t("please_input")} ${t(lableRef)}!`,
                },
              ]}
            >
              <Input
                placeholder={`${t("please_input")} ${t(lableRef)} ${t("example")} 20223xxc582....`}
                disabled={loading}
              />
            </Form.Item>

            <Form.Item className={`${showContent ? "animate" : "d-none"}`}>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading}
                loading={loading}
                icon={<SafetyCertificateOutlined />}
                style={styles.submitButton}
              >
                {loading ? t("verifying") : t("verify")}
              </Button>
            </Form.Item>
          </Form>

          {loading && (
            <div style={styles.loadingContainer}>
              <Spin tip={t("verifying_slip")} fullscreen size="large" />
            </div>
          )}
        </div>
      </>
    );
  }
}

const styles = {
  container: {
    // padding: "30px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    textAlign: "center",
  },
  form: {
    textAlign: "left",
  },
  submitButton: {
    width: "100%",
    height: "40px",
    fontSize: "16px",
    marginTop: "10px",
  },
  loadingContainer: {
    padding: "20px",
    textAlign: "center",
  },
  alert: {
    marginTop: "20px",
  },
  responseSection: {
    // marginTop: "30px",
    // borderTop: "1px dashed #e8e8e8",
    // paddingTop: "20px",
    // textAlign: "left",
  },
  jsonResponse: {
    backgroundColor: "#f0f2f5",
    padding: "15px",
    borderRadius: "4px",
    overflowX: "auto",
    fontFamily: "monospace",
    fontSize: "0.9em",
    color: "#333",
    maxHeight: "300px",
    marginBottom: "20px",
  },
};

export default ComponentVerifySlipOut;
